import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DataNotFound from "../../Components/DataNotFound";
import FollowUpRemarks from "../../Components/FollowUpRemarks";
import classes from "../../module.css/StmBookingCancellationByShowroomManager.module.css";
import ErrorMessage from "../../tailwindUI/ErrorMessage";
import Heading from "../../tailwindUI/Heading";
import Navbar from "../../tailwindUI/Navbar";
import Pagination from "../../tailwindUI/Pagination";
import StackedList from "../../tailwindUI/StackedList";
import SuccessMessage from "../../tailwindUI/SuccessMessage";
import TableHeader from "../../Components/TableHeader";
import FollowUpRemarkCbt from "../../Components/FollowUpRemarkCbt";
import ExcelDownload from "../../Components/ExcelDownload/ExcelDownload";
import CBTTAbleHeader from "../../Components/CBTTAbleHeader";
import Modal from "../../tailwindUI/Modal";
import Input from "../../tailwindUI/Input";
const ConfirmedBookingCancellations = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiFailled, setApiFailled] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");
  const [dataCount, setDataCount] = useState("");
  const [cbtCancellationRemark, setCBTCancellationRemark] = useState("");
  const [followUpModal, setFollowUpModal] = useState(false);
  const [carDatail, setCarDetail] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [allExcelData, setAllExcelData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const queryParams = new URLSearchParams(location.search);
  const page = parseInt(queryParams.get("page")) ? queryParams.get("page") : 1;
  const maxPages = Math.ceil(dataCount / 20);
  const [cbtOpen, setCBTOpen] = useState(false);

  useEffect(() => {
    ShowroomBookingcancledAPi();
  }, [searchTerm === "", page]);
  useEffect(() => {
    ShowroomBookingcancledAPi();
  }, [startDate, endDate]);
  const LogOut = () => {
    localStorage.removeItem("UserName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    localStorage.removeItem("UserToken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("Location");
    localStorage.removeItem("Email");
    localStorage.removeItem("UserLoggedin");
    navigate("/login", { replace: true });
  };
  const ShowroomBookingcancledAPi = () => {
    setLoading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: localStorage.getItem("UserToken"),
      page: page,
      SearchTerm: searchTerm,
      StartDate: startDate,
      EndDate: endDate,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/am/ConfirmCancelledCBT`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data ===
            "Invalid User Token, The token may have expired, You may need to re-login" &&
          result.message ===
            "Invalid User Token, The token may have expired, You may need to re-login"
        ) {
          LogOut();
        } else if (result.status_code === 200 && result.status === "Success") {
          setData(result.cancleddata);
          setDataCount(result.datacount);
          setAllExcelData(result.cancleddata);
        } else {
          setApiFailled(true);
          setMessage(result.Reason);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setLoading(""));
  };

  // const formValidation = () => {
  //   let errors = {};
  //   let isValid = true;

  //   if (!addRemark || addRemark === "") {
  //     errors.addRemark = "Please Enter Remark First";
  //     isValid = false;
  //   }

  //   setError(errors);
  //   return isValid;
  // };

  const SuccessApi = () => {
    //  return console.log(carDatail,"56444444444444444444")
    const myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);

    const formdata = new FormData();
    formdata.append("UserToken", localStorage.getItem("UserToken"));
    formdata.append("BookingID", carDatail.BookingID);
    formdata.append("CBTCancellationRemark", cbtCancellationRemark);
    formdata.append("MoveToConfirmCancel", "1");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/am/MoveToConfirmCancelledAndCBTRemark`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.message === "data updated successfully"
        ) {
          // setViewText(true);
          setTimeout(() => {
            setCBTOpen(false);
            setMessage("Remark Updated Sucessfully");
            ShowroomBookingcancledAPi();
          }, 2000);
        }
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage(error.message);
      })
      .finally(() => {
        console.log("Error in finally");
      });
  };
  const followUpHandler = (carDetail) => {
    setFollowUpModal(true);
    setCarDetail(carDetail);
  };
  const successMessage = () => {
    setTimeout(() => {
      setMessage("");
    }, 3000);
    return message;
  };

  const cbtCancellation = (BookingDetail) => {
    setCarDetail(BookingDetail);
    setCBTOpen(true);
  };
  const admin = localStorage.getItem("Location");

  return (
    <div>
      {message && (
        <SuccessMessage
          onClose={() => setMessage("")}
          message={successMessage()}
          apiFailled={apiFailled}
        />
      )}
      {errorMessage && <ErrorMessage message={errorMessage} />}
      {cbtOpen && (
        <Modal
          setOpen={setCBTOpen}
          heading={"CBT Cancellation Remark"}
          open={cbtOpen}
          onCancel={() => {
            setCBTOpen(false);
            setCBTCancellationRemark("");
          }}
          onClick={() => SuccessApi()}
          type="Simple alert"
        >
          <div className="mt-2">
            <Input
              type={"textarea"}
              label="CBT Cancellation Remark"
              placeholder="Enter CBT Remark"
              value={cbtCancellationRemark}
              onChange={(e) => {
                setCBTCancellationRemark(e.target.value);
              }}
            />
          </div>
        </Modal>
      )}
      {message && (
        <SuccessMessage
          onClose={() => setMessage("")}
          message={successMessage()}
          apiFailled={apiFailled}
        />
      )}
      {errorMessage && <ErrorMessage message={errorMessage} />}
      {followUpModal && (
        <FollowUpRemarks
          bookingData={carDatail}
          setOpen={setFollowUpModal}
          open={followUpModal}
          onClose={() => setFollowUpModal(false)}
        />
      )}
      <Navbar navbarType={"CBT"} />
      <div className={classes.maincontainer}>
        <Heading
          headingType={"Page Headings"}
          headingText={"Confirmed Booking Cancellations by CBT"}
        />
        <div className={classes.background}>
          <CBTTAbleHeader
            buttonText="Search"
            tableHeading="Search Criteria"
            subHeading="subHeading"
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            totalResult={dataCount}
            pageResult={data.length}
            placeholderType="Enter Model,Variant,Color,Outlet (For Example:-Grand,i10,Fiery red,Telibagh)"
            apicall={ShowroomBookingcancledAPi}
            setSearchTerm={setSearchTerm}
            searchTerm={searchTerm}
          />
          <div>
            <div className="my-2 text-end">
              <ExcelDownload
                csvData={allExcelData}
                fileName="Confirm Booking Cancellation List"
              />
            </div>
          </div>
          {loading ? (
            <div className={"w-full bg-white  "}>
              <img
                className="m-auto"
                src="../assets/loadingGif.gif"
                alt="loading"
              />
            </div>
          ) : (
            <>
              {data?.length > 0 ? (
                <>
                  {data?.map((item) => {
                    return (
                      <div className={classes.list}>
                        <div className={classes.stackListContainer}>
                          <div role="list" className={classes.stackListWrapper}>
                            <StackedList
                              type="Stm-booking-confirm-cancellation-by-showroom-manager"
                              data={item}
                              admin={admin}
                              RemarkHandler={followUpHandler}
                              buttonHide={"Hide"}
                              cbtCancellation={cbtCancellation}
                              setCBTCancellationRemark={
                                setCBTCancellationRemark
                              }
                              Type="CBT"
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <DataNotFound />
              )}
            </>
          )}

          <div className="bg-white">
            {maxPages > 1 && <Pagination maxPages={maxPages} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmedBookingCancellations;
